import { AlertButton, AlertType } from "react-native";

const Alert = {
    alert(title: string, message?: string, buttons?: AlertButton[]): void {
        if (buttons === undefined || buttons.length === 0) {
            window.alert([title, message].filter(Boolean).join("\n"));
            return;
        }

        const result = window.confirm([title, message].filter(Boolean).join("\n"));

        if (result === true) {
            const confirm = buttons.find(({ style }) => style && style !== "cancel");
            confirm?.onPress?.();
            return;
        }

        const cancel = buttons.find(({ style }) => style && style === "cancel");
        cancel?.onPress?.();
    },

    prompt(
        title: string,
        message?: string,
        callbackOrButtons?: ((text: string) => void) | AlertButton[],
        type?: AlertType,
        defaultValue?: string,
    ): void {
        const result = window.prompt(`${title}\n\n${message}`, defaultValue);

        if (callbackOrButtons === undefined) {
            return;
        }

        if (typeof callbackOrButtons === "function") {
            if (result) {
                callbackOrButtons(result);
            }
        } else {
            // Handle AlertButton array case
            if (result) {
                const confirm = callbackOrButtons.find(({ style }) => style && style !== "cancel");
                confirm?.onPress?.();
            } else {
                const cancel = callbackOrButtons.find(({ style }) => style && style === "cancel");
                cancel?.onPress?.();
            }
            return;
        }
    },
};

export { Alert };
